import moment from 'moment';

/**
 * Shared debt-estado derivation: pagada (saldo <= 0, at least one cuota
 * generated), vencida (closeDate ?? endDate is in the past), else activa.
 * Used by both the Accounts > Deudas tab and the Debt Detail header/tabs so
 * there's exactly one implementation of this rule.
 */
export function debtEstado(debt) {
	if ((debt.saldo || 0) <= 0 && debt.cuotasTotal > 0) {
		return 'pagada';
	}
	const dueDate = debt.closeDate ?? debt.endDate;
	if (dueDate && moment.utc(dueDate).isBefore(moment.utc())) {
		return 'vencida';
	}
	return 'activa';
}

export const DEBT_ESTADO_TONE = { pagada: 'ok', vencida: 'danger', activa: 'accent' };
export const DEBT_ESTADO_LABEL = { pagada: 'Pagada', vencida: 'Vencida', activa: 'Activa' };
